import React, { useEffect, useRef, useState } from "react";
import { Bell, Megaphone } from "lucide-react";
import api from "@/api";

export default function CoordinatorBell() {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const load = () => {
    api.get("/coordinator/notifications").then((r) => { setItems(r.data.items || []); setUnread(r.data.unread || 0); }).catch(() => {});
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next && unread > 0) {
      try { await api.post("/coordinator/notifications/read-all"); setUnread(0); load(); } catch { /* ignore */ }
    }
  };

  const fmt = (d) => { try { return new Date(d).toLocaleString("ar"); } catch { return ""; } };

  return (
    <div className="relative" ref={ref}>
      <button data-testid="notifications-bell" onClick={toggle} className="relative p-2 rounded-lg hover:bg-sky-100 text-sky-600 transition">
        <Bell size={20} />
        {unread > 0 && (
          <span data-testid="notif-badge" className="absolute -top-0.5 -left-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center">{unread > 99 ? "99+" : unread}</span>
        )}
      </button>
      {open && (
        <div data-testid="notif-panel" className="absolute left-0 mt-2 w-96 max-w-[92vw] glass rounded-2xl shadow-xl border border-sky-200/50 z-[70] p-2" dir="rtl">
          <div className="flex items-center gap-2 px-2 py-2 border-b border-sky-200/40">
            <Megaphone size={16} className="text-amber-600" />
            <span className="font-head font-bold text-sm text-stone-800">توجيهات المدير</span>
          </div>
          <div className="max-h-80 overflow-y-auto">
            {!items.length ? (
              <p className="text-center text-stone-500 text-sm py-8">لا توجد توجيهات بعد</p>
            ) : items.map((n) => (
              <div key={n.id} data-testid={`notif-item-${n.id}`} className={`flex gap-2 p-3 rounded-xl my-1 ${n.read ? "" : "bg-sky-50/70"}`}>
                <div className="w-8 h-8 rounded-full bg-amber-500/15 flex items-center justify-center shrink-0"><Megaphone size={16} className="text-amber-600" /></div>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-semibold text-stone-800">{n.title}</div>
                  <div className="text-xs text-stone-600 whitespace-pre-wrap">{n.message}</div>
                  <div className="text-[10px] text-stone-400 mt-1">{fmt(n.created_at)}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
